import './styles.scss'

import { useTranslation } from 'react-i18next'
import { Col, Form, Input, Radio, Row } from 'antd'

import DeliveryDate from '@/components/B2bDeliveryDate'
import FormatPrice from '@/components/FormatPrice'
import { useAppSelector } from '@/store/hook'
import { selectHideEstimatedDeliveryTime } from '@/store/selectors/configSelector'
import { useCheckoutContext } from '@/contexts/checkout/useCheckoutContext'

export default function ShippingOptions() {
  const { t } = useTranslation()
  const { cartData } = useCheckoutContext()
  const isHideEstimatedDeliveryTime = useAppSelector(selectHideEstimatedDeliveryTime)

  const dataSource = cartData
    ? [
      {
        title: t('common.shippingOptions.standardDelivery'),
        value: cartData.shippingCosts,
        desc: 'Get it by Friday, Oct 30 , November 5',
        currencyUnit: cartData?.currencyUnit,
      },
    ]
    : null

  const deliveryDatesByDateData = cartData
    ? cartData.deliveryDatesByDateData
    : []

  const deliveryData = Object.keys(deliveryDatesByDateData).map(
    (deliveryDate) => {
      const numberOfItems = deliveryDatesByDateData[deliveryDate]
        .map(({ numberOfItems: quantity }) => quantity)
        .reduce((sum, quantity) => sum + quantity, 0)

      return {
        deliveryDate,
        numberOfItems,
      }
    },
  )

  const renderContent = (data) => {
    return (
      <Radio.Group
        className="shipping-options--wrapper custom-form-item"
        style={{
          marginBottom: cartData?.checkoutSettings?.shippingNotes ? 0 : '30px',
        }}
      >
        {data.map((item) => (
          <Radio key={item.value} value={item.value}>
            <div className="shipping-options--container">
              <div className="shipping-options--container--left">
                <strong className="shipping-options__title">
                  {item.title}
                </strong>
                <div className="delivery-date">
                  {!isHideEstimatedDeliveryTime && <DeliveryDate deliveryData={deliveryData} />}
                </div>
              </div>
              <div className="shipping-options--container--right">
                <FormatPrice
                  currencyUnit={item?.currencyUnit}
                  price={item?.value}
                  wrappedBy="strong"
                />
              </div>
            </div>
          </Radio>
        ))}
      </Radio.Group>
    )
  }

  return (
    <Row className="payment-method__wrapper checkout-step1-section__wrapper">
      <Col lg={5} md={4} sm={24} xl={5} xs={24}>
        <h3 className="shipping-options__heading">
          {t('checkout.step2.shippingOptions')}
        </h3>
      </Col>
      {dataSource && (
        <Col lg={13} md={20} sm={24} xl={13} xs={24}>
          <Form.Item
            noStyle
            initialValue={dataSource[0].title}
            name="shippingMethod"
          >
            <Input type="hidden"></Input>
          </Form.Item>
          <Form.Item initialValue={dataSource[0].value} name="shippingOptions">
            {renderContent(dataSource)}
          </Form.Item>
        </Col>
      )}
    </Row>
  )
}
